import React from 'react';
import { NCZIFolder } from '../../../../Interfaces/ncziTypes';
import EHRComposition from '../EHRComposition/EHRComposition';
// @ts-ignore
import styles from './EHRFolder.module.scss';

interface Props {
	folder: NCZIFolder | undefined;
}

const EHRFolder: React.FC<Props> = props => {
	const { folder } = props;

	if (!folder) {
		return <></>;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.folderName}>
				<img src='../../dist/icons/folder-solid.svg' />
				{folder.name}
			</div>
			<div className={styles.folderContent}>
				{folder.children.map((subFolder, key) => (
					<EHRFolder folder={subFolder} key={key} />
				))}
				{folder.compositions.map((item, key) => (
					<EHRComposition item={item} key={key} />
				))}
			</div>
		</div>
	);
};

export default EHRFolder;
